import "./App.css";
import Countries from "./components/Countries/Countries";


function App() {
  return (
    <div className="App">
      <Countries></Countries>
    </div>
  );
}





/* function LoadCountries() {
  const [counties, setCountries] = useState([]);
  useEffect(() => {
    fetch("https://restcountries.com/v3.1/all")
      .then((res) => res.json())
      .then((data) => setCountries(data));
  }, []);
  return (
    <div>
      <h1>Visiting every country of the world !!!!!!!!</h1>
      {
        counties.map(country => <Country name={country.name.common} population={country.population}></Country>)
      }
    </div>
  );
}

function Country (props){
  return(
    <div>
      <h2>{props.name}</h2>
      <h4>population: {props.population}</h4>
    </div>
  )
} */
export default App;
